import React from "react";

export default function ModalButton(props) {

    const { value = "", style = {}, onClick = () => {} } = props;

    return (<div onClick={onClick} style={{ ...style }} className="ui-modal-button">{value}</div>)
}